/**
 * Who owns an event.
 *
 * Ownership decides neither editing nor nominations. Any marketer or admin may edit, publish and
 * unpublish any event (EventService, changed at PM request), so the pages gate on role
 * (`canManageEvents`) alone; only DeleteEvent stays creator-or-admin, and the UI offers no delete.
 * Approve / Reject does not depend on it either — that is by role and submitter (see
 * authorization `mayDecideNomination`). The owner is shown, as the Event Owner column.
 *
 * Here rather than inline in the pages because the coverage config measures only `.ts`.
 */

import type { Event } from '../client/EventCalendarClient';

/**
 * The event's owner login, or undefined when the event does not name one.
 *
 * `eventOwner` is the field the create form sets and a marketer can hand over later;
 * `createdBy` is audit and never changes. Ownership follows `eventOwner` and falls back to
 * `createdBy`, so an event predating the field — or one created by a path that did not set
 * it — still has an owner rather than being decidable by nobody.
 */
export function ownerOf(event: Event | undefined): string | undefined {
  const owner = event?.eventOwner?.trim() || event?.createdBy?.trim();
  return owner || undefined;
}
